import * as Yup from 'yup';

export const formConstants = {
  defaultShippingMethod: {
    name: 'defaultShippingMethod',
    label: 'Default Shipping Method',
    description:
      'This will be the default shipping method for all shipments created for this organization.',
  },
  defaultShippingCarrier: 'defaultShippingCarrier',
  defaultShippingService: 'defaultShippingService',
  defaultShippingLocation: {
    name: 'defaultShippingDestinationLocation',
    label: 'Default Shipping Location',
    description:
      'This will be the default shipping location for shipments created for this organization.',
  },
  defaultCofactrWarehouse: {
    name: 'defaultCofactrWarehouse',
    label: 'Default Cofactr Warehouse',
    description:
      'This will be the default Cofactr warehouse that orders will be shipped to and kits will be shipped from.',
  },
  defaultShippingPartial: {
    name: 'defaultShippingPartial',
    label:
      'Send a partial shipment by the specified deadline if only some parts are available to ship',
    description:
      'These will be the default preferences for shipments created for this organization.',
  },
  upsAccountNumber: {
    name: 'upsAccountNumber',
    label: 'UPS Account Number',
  },
  upsAccountCountry: {
    name: 'upsAccountCountry',
    label: 'UPS Account Country',
  },
  upsAccountPostalCode: {
    name: 'upsAccountPostalCode',
    label: 'UPS Account Postal Code',
  },
  fedexAccountNumber: {
    name: 'fedexAccountNumber',
    label: 'FedEx Account Number',
  },
  fedexAccountCountry: {
    name: 'fedexAccountCountry',
    label: 'FedEx Account Country',
  },
  fedexAccountPostalCode: {
    name: 'fedexAccountPostalCode',
    label: 'FedEx Account Postal Code',
  },
};

export const formValidation = Yup.object().shape({
  [formConstants.defaultShippingMethod.name]: Yup.string(),
  [formConstants.defaultShippingLocation.name]: Yup.string(),
  [formConstants.defaultShippingPartial.name]: Yup.boolean(),
  [formConstants.upsAccountNumber.name]: Yup.string().nullable(),
  [formConstants.upsAccountCountry.name]: Yup.string().nullable(),
  [formConstants.upsAccountPostalCode.name]: Yup.string().nullable(),
  [formConstants.fedexAccountNumber.name]: Yup.string().nullable(),
  [formConstants.fedexAccountCountry.name]: Yup.string().nullable(),
  [formConstants.fedexAccountPostalCode.name]: Yup.string().nullable(),
});
